module.exports = __webpack_public_path__ + "static/blog-placeholder@2x-38f533f4bf60c8d9dc8c75cef19efec2.png";